import { ConfirmModal } from '@base-app';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ResetMFAModalProps } from './ResetMFAModal.types';

const ResetMFAModal: FC<ResetMFAModalProps> = ({ onCancel, onConfirm, show, selectedUserId }) => {
  const { t } = useTranslation(['teams', 'common']);
  return (
    <ConfirmModal
      cancelAction={{
        onClick: onCancel,
        text: t('modal_cancel', { ns: 'common' }),
      }}
      data={selectedUserId}
      confirmAction={{
        onClick: onConfirm,
        text: t('reset_mfa_modal_confirmation'),
      }}
      show={show}
      title={t('reset_mfa_modal_title')}
    />
  );
};

export default ResetMFAModal;
